export default __webpack_public_path__ + "static/media/logos.a72c3c8b.svg";